export const getMapBoundsForFindCars = (
  map,
  maps,
  taggedCarsSaverGlobalState,
  carData,
  allCarData,
  isValidLocation,
  setNotAvailableCars,
  getMapBoundsForAllCars,
  setOpenPopupNotAvailableCars,
  setAll
) => {
  let taggedCars = JSON.parse(JSON.stringify(taggedCarsSaverGlobalState));

  taggedCars.forEach((item) => {
    const existsInCarData = carData.find((car) => car.CarNumber === item);

    if (!existsInCarData) {
      const fromAllData = allCarData.find((allItem) => allItem.Car.CarNumber === item);
      if (fromAllData) carData.push(fromAllData);
    }
  });

  let notAvailableCarsTemp = [];
  let availableCarsTemp = [];

  // filter instead of mutating while iterating
  const validTaggedCars = taggedCars.filter((item) => {
    const found = carData.find((carItem) => carItem.Car.CarNumber === item && isValidLocation(carItem.Car.Latitude, carItem.Car.Longitude));

    if (!found) {
      notAvailableCarsTemp.push(item);
      return false;
    }

    availableCarsTemp.push(item);
    return true;
  });

  if (notAvailableCarsTemp.length > 0) {
    setNotAvailableCars([...notAvailableCarsTemp]);
    setOpenPopupNotAvailableCars(true);

    if (availableCarsTemp.length > 0) {
      const bounds = new maps.LatLngBounds();

      carData.forEach((place) => {
        if (validTaggedCars.includes(place.Car.CarNumber)) {
          bounds.extend(
            new maps.LatLng(Number(place.Car?.Latitude), Number(place.Car?.Longitude)));
        }
      });

      return bounds;
    }

    return getMapBoundsForAllCars(
      map,
      maps,
      allCarData,
      isValidLocation,
      setAll
    );
  }

  const bounds = new maps.LatLngBounds();

  carData.forEach((place) => {
    if (validTaggedCars.includes(place.Car.CarNumber)) {
      bounds.extend(
        new maps.LatLng(Number(place.Car?.Latitude), Number(place.Car?.Longitude)));
    }
  });

  return bounds;
};